import 'jquery/dist/jquery.min.js';
import Endpoints from '@/config/ApiEndpoints.js';
import Axios from 'axios';
import $ from 'jquery';
import Swiper, {navigation} from 'swiper';
import { required, email, minLength, sameAs } from 'vuelidate/lib/validators';
import UpcomingEvent from '@/pages/upcomingevent/upcomingevent';
import DriverProfilePicture from '@/pages/drivers/driverprofilepicture/driverprofilepicture';
import LicenceCategories from "@/assets/json_data/licence_categories.json";
import DriverTag from '@/pages/drivers/drivertag/drivertag';
import VehicleRegistrationRegion from "@/assets/js/vehicle_registration_region.js";
import DeleteImage from '@/pages/operations/deleteimage/deleteimage';
import DriverAdditionalFields from "@/assets/js/const.js";
import DriverNames from "@/assets/js/driver_names.js";
import Notes from '@/pages/drivers/notes/notes';
import AddNotes from '@/pages/drivers/addnotes/addnotes';
import DriverAssets from '@/pages/drivers/driverassets/driverassets.vue';
import VueHtml2pdf from "vue-html2pdf";
import Task from "@/pages/task/task";
import SendMessage from "@/pages/send_custom_notification/sendmessage";
import AuditLogs from '@/pages/auditlog/auditlogdata/auditlogdata.vue';

import GetcurrencySymbol from "@/assets/js/currency_sign.js";
//import { set } from 'core-js/core/dict';
var moment = require("moment");
export default {
	components:{
		UpcomingEvent,
		DriverProfilePicture,
		DriverTag,DeleteImage,
		Notes,
		AddNotes,
		DriverAssets,
		VueHtml2pdf,
		SendMessage,
		Task,
		AuditLogs
	},
	setup() {
		return {};
	},
	filters: {
        date: function(data) {
			var sendDate = "N/A";
			if (data != "" && data != null) {
			sendDate = moment(data).format("MM-YYYY");
			}
			return sendDate;
        },
		region: function(data){
			return VehicleRegistrationRegion(data);
		},
		getDriverNames: function(data){
			return DriverNames(data);
		},
		date_full: function(data) {
        	var sendDate = "N/A";
			if (data != "" && data != null) {
			sendDate = moment(data).format("DD-MM-YYYY");
			}
			return sendDate;
        },
		str_limit(value, size) {
			if (!value) return "";
			value = value.toString();
	
			if (value.length <= size) {
			  return value;
			}
			return value.substr(0, size) + "...";
		  },
    },
	data() {
		return {
			currency_type : GetcurrencySymbol(),
			DocumentEndpoint: Endpoints.Helper.Image+ '/',
			ImageEndpoint: Endpoints.Helper.GenerateImage+ '/',
			ShowLoader: false,
			PrintLoader: false,
			Saving: false,
			SavingEmp: false,
			SavingLicense: false,
			SavingCPC: false,
			SavingADR: false,
			SavingHealth: false,
			SavingFile: false,
			submitted: false,
			editForm:false,
			editEmpForm:false,
			editLicenseForm:false,
			editCPCForm:false,
			editADRForm:false,
			editHealthForm:false,
			vehicleLoop:true,
			hgvModule:false,
			ShowMap: false,
			ShowFileInput: false,
			locationPoints: "",
			center: {
				lat: 55.232753,
				lng: -3.944403,
			},
			infoOptions: {
				pixelOffset: {
				width: 0,
				height: -35,
				},
				content: "",
			},
			Categories:LicenceCategories,
			LicenceCatInfo:'',
			CurrentLicenceDoc:'',
			CurrentCPCDoc:'',
			CurrentADRDoc:'',
			front_file: "",
			back_file: "",
			base64_image: "",
			license_front_image: "",
			license_back_image: "",
			Vehicles:[],
			Vehicle:[],
			VehicleList:[],
			DriverId:0,
			DriverAdditionalFieldData:'',
			UpcomingEventNewHeight:335,
			UpcomingEventNewHeightKey:0,
			UploadPopupKey:0,
			UpcomingEventNewHeightWithDoc:160,
			ComponentKey: 0,
			ProfilePicColor:'576E7A',
			DriverColor:[],
			Branches:{},
			NewDriver: {
				branch_id:0,
				vehicle_id: '',
				forename: '',
				surname: '',
				phone: '',
				email: '',
				address: '',
				post_code: '',
				dob: '',
				ni_number: '',
				next_of_kin: '',
				ice_contact: '',
				image: '',
				image_url: '',
				company_name: '',
				company_start_date: '',
        		company_driver_id: '',
				company_position: '',
				company_phone: '',
				company_email: '',
				company_driver_type: 'Grey',
				account_type: 'Driver',
				license_category: [],
				license_expiry: '',
				license_number: '',
				license_codes: '',
				penality_points: '',
				notes: '',
				driver_vehicle: '',
				license_check_date:'',
				receive_email:false
			},
			NewDocument: {},
			PopupLoader:false,
			AssginVehicle:{'driver_id':0,'vehicle_id':0},
			Notes:{'title':'','notes':''},
			Documents:[],
			DocumentSubcategories:'',
			DocFilter:'All',
			ViewDocument : {},
			UpcomingEvent: {},
			ShowViewDetailModel: false,
			DocumentModelCategories:[],
			DocumentModelSubCategories : [],
			DocumentModelFields : {},
			AddDocumentFormType:'',
			AccountPermissions:[],
			FleetSubscription:[],
			ShowDriverEdit:false,
			ShowDriverDelete:false,
			ShowDriverAssignVehicle:false,
			ShowDocumentAdd:false,
			ShowDocumentDownload:false,
			ShowUrgentTask:false,
			ShowDocuments:false,
			ShowAssignVehicle:false,
			ShowAddNotePopup:false,
			SelectAllVehicle: false,
			notes: {},
			
			SelectedDrivers:[],
			NotificationHeading:"",
			ShowNotifications: false,
			todaysUrgentTaskNew: window.todaysUrgentTaskNew,
		}
	},
	validations: {
	   NewDriver: {
			forename: { required },
			surname: { required },
			//phone: { required,minLength: minLength(10) },
			email: { required,email },
			//dob: { required },
			//ni_number: { required },
			//next_of_kin: { required },
			//ice_contact: { required },
			//license_category: { required },
			//license_expiry: { required },
			//license_number: { required },
	    },
  	},
	mounted() {
		var AccountPermissions = JSON.parse(
		localStorage.getItem("AccountPermissions")
		);
		this.FleetSubscription = JSON.parse(
		localStorage.getItem("FleetSubscription")
		);
		this.AccountPermissions = AccountPermissions;
	
		var FleetSubscriptionModules = JSON.parse(
		this.FleetSubscription.fleet_modules
		);
		if(FleetSubscriptionModules["Hierarchy System"] && (!AccountPermissions.Driver || !AccountPermissions.Driver.enable)){
			this.$router.push('/');
		}
		if (this.AccountPermissions && 
		this.AccountPermissions.Driver &&
		this.AccountPermissions.Driver.enable) {
			if ( this.AccountPermissions.Driver.edit) {
				this.ShowDriverEdit = true;
			}
			if ( this.AccountPermissions.Driver.delete) {
				this.ShowDriverDelete = true;
			}
			if ( this.AccountPermissions.Driver.assign_vehicle) {
				this.ShowDriverAssignVehicle = true;
			}
		}
		if (this.AccountPermissions && 
			this.AccountPermissions.Documents &&
			this.AccountPermissions.Documents.enable) {
				this.ShowDocuments = true;
			if ( this.AccountPermissions.Documents.add) {
				this.ShowDocumentAdd = true;
			}
			if ( this.AccountPermissions.Documents.download) {
				this.ShowDocumentDownload = true;
			}
		}

		if (AccountPermissions && 
			AccountPermissions['Vehicle Checks'] &&
			AccountPermissions['Vehicle Checks']['enable']) {
			if ( AccountPermissions['Vehicle Checks']['view_urgent_task']) {
				this.ShowUrgentTask = true;
			}
		}

		this.ShowNotifications = (FleetSubscriptionModules["Notifications"]);


		if (!FleetSubscriptionModules["Hierarchy System"]) {
			this.ShowDriverEdit = true;
			this.ShowDriverDelete = true;
			this.ShowDriverAssignVehicle = true;
			this.ShowDocumentAdd = true;
			this.ShowDocumentDownload = true;
			this.ShowUrgentTask = true;
			this.ShowDocuments = true;
		}

		var Company = JSON.parse(localStorage.getItem("Company"));
	    if (Company && Company.name) {      
			if(window.taskModuleCompanies.includes(Company.id)){ 
	      	this.todaysUrgentTaskNew = true
	      }
	    }

		
		document.title = pbx_SiteTitle+' - Driver Profile';
		this.DriverId = this.$route.params.DriverId;
		this.GetDriverDetail();
		this.GetDriverDocument();
		this.GetCompanySubscription();
		this.GetBranches();
		this.DocumentModelLoadCategories();
		this.GetDriverDocumentSubcategories();
		this.GetVehiclesListForDocument();
		//this.GetUpcomingEventList();
		//this.showSlides(slideIndex);
		/* set random color*/
		if(sessionStorage.getItem("DriverColor") != null){
			this.DriverColor = JSON.parse(sessionStorage.getItem("DriverColor"));
			if(typeof this.DriverColor[this.DriverId] != undefined){
				this.ProfilePicColor = this.DriverColor[this.DriverId];
			}
		}
		/******************************/
		this.DriverAdditionalFieldData = DriverAdditionalFields();
	},

	methods : {
		setDriver(driverID, driverName){
			this.SelectedDrivers = [];
			this.SelectedDrivers.push(driverID);
			this.NotificationHeading = driverName;
		},
		messageSent() {
			this.SelectedDrivers = [];
		},
		checkVehicle(e) {
			if (e.target.checked) {
			  this.SelectAllVehicle = true;
			  //this.SelectDriver = true;
			  this.NewDocument.fields["vehicle"]["value"] = [];
			  this.VehicleList.forEach((element) => {
				this.NewDocument.fields["vehicle"]["value"].push(element.id);
			  });
			} else {
			  this.ResetVehicleArray();
			}
		  },
		  selectVehicle: function () {
			this.SelectAllVehicle = false;
		  },
		  ResetVehicleArray() {
			this.SelectAllVehicle = false;
			//this.SelectDriver = false;
			this.NewDocument.fields["vehicle"]["value"] = [];
			return true;
		  },
		GetVehiclesListForDocument() {
			if (sessionStorage.getItem("DocumentVehicles")) {
			  this.VehicleList = JSON.parse(sessionStorage.getItem("DocumentVehicles"));
			} else {
			  var obj = { token: localStorage.getItem("token") };
			  Axios.post(Endpoints.Dcoument.VehicleList, obj).then((Response) => {
				if (Response?.data?.success) {
				  this.VehicleList = Response.data.vehicles;
				  sessionStorage.setItem(
					"DocumentVehicles",
					JSON.stringify(this.VehicleList)
				  );
				}
			  });
			}
		},
		AddNote(){
			this.$refs.add_notes_section.NewNoteOpen();
		  },
		LoadNotesData(){
			this.$refs.notes_section.GetNotesList();
		},
		GeneratePDF() {
			this.PrintLoader = true;
			
			if(this.NewDriver.image){
				var obj = { token: localStorage.getItem("token"), url: this.ImageEndpoint+'driver/146x146/'+ this.NewDriver.image};
				Axios.post(Endpoints.File.GetBase64Image, obj).then((Response) => {
					if (Response?.data?.success) {
						this.base64_image = Response.data.image_data;
						this.$refs.html2Pdf.generatePdf({ useCORS: true });
					}
				});
			}else{
				this.base64_image = '';
				this.$refs.html2Pdf.generatePdf({ useCORS: true });
			}
		  },
		  PDFDownloaded() {
			this.PrintLoader = false;
		  },
		  GetDriverNotesList() {
			let formData = new FormData();
			formData.append("token", localStorage.getItem("token"));
			formData.append("item_id", this.NewDriver.id);
			formData.append("type", 2);
			Axios.post(Endpoints.Notes.List, formData).then((Response) => {
			  if (Response?.data?.success == true) {
				this.notes = Response.data.notes;
			  }
			});
		  },
		showInput(event) {
			if (event.target.checked) {
			  this.ShowFileInput = true;
			} else {
			  this.ShowFileInput = false;
			}
		  },
		GetBranches(){
			var obj = { token: localStorage.getItem("token"), select_branch: true };
			Axios.post(Endpoints.Branch.List, obj).then((Response) => {
				if (Response?.data?.success) {
				this.Branches = Response.data.records;
				}
			});
		},
		GetCompanySubscription(){
			var FleetSubscriptionModules = JSON.parse(
				JSON.parse(localStorage.getItem("FleetSubscription")).fleet_modules
			  );
			  const isHGV = FleetSubscriptionModules.HGV;
			  if(isHGV){
				this.hgvModule = true;
			}
		},
		loadText(selectObject){
			var text = $('.lic_category option:selected').attr('description');
			this.LicenceCatInfo = text;
		},
		AddDocument(category,sub_category) {
			this.AddDocumentFormType='add_'+category+'_'+sub_category;
			this.DocumentModelFields = {};
			$("#file").val(null);
			this.file = "";
			this.PopupLoader = true;
			Axios.post(Endpoints.Dcoument.Model, {
			  token: localStorage.getItem("token"),
			  category: category,
			  sub_category: sub_category,
			}).then((Response) => {
			  this.PopupLoader = false;
			  if (Response?.data?.success == true && Response.data.models[0]) {
				var model = Response.data.models[0];
				this.NewDocument.title = model.title;
				this.NewDocument.category = model.category;
				this.NewDocument.sub_category = model.sub_category;
				this.NewDocument.fields = JSON.parse(model.fields);
				this.DocumentModelFields = JSON.parse(model.fields);
				this.NewDocument.type = sub_category;
				this.UploadPopupKey += 1;

				if(category == 'identification' && sub_category == 'driving_license'){
					this.NewDocument.type = 'driving_license';
					if (this.NewDocument.fields && this.NewDocument.fields.license_number) {
						this.NewDocument.fields.license_number.value = this.NewDriver.license_number;
					} 
					if (this.NewDocument.fields && this.NewDocument.fields.forename) {
						this.NewDocument.fields.forename.value = this.NewDriver.forename;
					}
					if (this.NewDocument.fields && this.NewDocument.fields.surname) {
						this.NewDocument.fields.surname.value = this.NewDriver.surname;
					}
					if (this.NewDocument.fields && this.NewDocument.fields.dob) {
						this.NewDocument.fields.dob.value = this.NewDriver.dob;
					}
					if (this.NewDocument.fields && this.NewDocument.fields.expiry) {
						this.NewDocument.fields.expiry.value = this.NewDriver.cpc_expiry;
					}
				}
				if(category == 'certificate' && sub_category == 'CPC'){
					this.NewDocument.type = 'cpc_certificate';
					if (this.NewDocument.fields && this.NewDocument.fields.expiry) {
						this.NewDocument.fields.expiry.value = this.NewDriver.cpc_expiry;
					}
				}
				if(category == 'certificate' && sub_category == 'ADR'){
					this.NewDocument.type = 'adr_certificate';
					if (this.NewDocument.fields && this.NewDocument.fields.expiry) {
						this.NewDocument.fields.expiry.value = this.NewDriver.adr_expiry;
					}
				}
			  }
			});
		},
		handleFileUpload() {
			this.file = this.$refs.file.files[0];
		},
		handleFrontFileUpload() {
		this.front_file = this.$refs.front_file.files[0];
		this.StorageType = "CFD";
		},
		handleBackFileUpload() {
		this.back_file = this.$refs.back_file.files[0];
		this.StorageType = "CFD";
		},
		UploadFrontFile() {
			if (this.front_file != "" && this.back_file != "") {
			  $("#upload_img_btn").html("Processing...");
			  this.PopupLoader = true;
			  let formData = new FormData();
			  formData.append("token", localStorage.getItem("token"));
			  formData.append("storage_type", this.StorageType);
			  formData.append("file", this.front_file);
			  Axios.post(Endpoints.File.Upload, formData).then((Response) => {
				this.PopupLoader = false;
				if (Response?.data?.success == true) {
				  this.license_front_image = Response.data.file;
				  this.UploadBackFile();
				} else {
				  this.$swal("Error in File Uploading", "", "error").then(() => {});
				}
			  });
			} else {
			  this.$swal(
				"Please choose license front and back image",
				"",
				"error"
			  ).then(() => {});
			}
		  },
		  UploadBackFile() {
			this.PopupLoader = true;
			let formData = new FormData();
			formData.append("token", localStorage.getItem("token"));
			formData.append("storage_type", this.StorageType);
			formData.append("file", this.back_file);
			Axios.post(Endpoints.File.Upload, formData).then((Response) => {
			  this.PopupLoader = false;
			  if (Response?.data?.success == true) {
				this.license_back_image = Response.data.file;
				this.GenerateLicensePdf();
			  } else {
				this.$swal("Error in File Uploading", "", "error").then(() => {});
			  }
			});
		  },
		  GenerateLicensePdf() {
			this.PopupLoader = true;
			let formData = new FormData();
			formData.append("token", localStorage.getItem("token"));
			formData.append("front_image", this.license_front_image);
			formData.append("back_image", this.license_back_image);
			Axios.post(Endpoints.Dcoument.GenerateLicensePdf, formData).then(
			  (Response) => {
				this.PopupLoader = false;
				if (Response?.data?.success == true) {
				  this.NewDocument.files = Response.data.file;
				  this.NewDocument.filename = Response.data.file;
				  $("#upload_img_btn").html("Upload Front / Back Image");
				  this.AddDocumentSubmit();
				} else {
				  this.$swal("Error in File Uploading", "", "error").then(() => {});
				}
			  }
			);
		  },
		  SaveDocumentSubmit() {
			var error = false;
			var errorStr = "";
			if (this.NewDocument.fields) {
				for (const [key, ele] of Object.entries(this.NewDocument.fields)) {
					if (ele.required && (!ele.value || ele.value == "")) {
					error = true;
					errorStr += "<li>Please Enter " + ele.title + "</li>";
					}
				}
			}
			if (error == true) {
				this.$swal
					.fire("Following Error Found!", errorStr, "error")
					.then(() => {});
				} else {
					
        if(this.ShowFileInput){
				if (this.front_file != "" && this.back_file != "") {
					this.PopupLoader = true;
					$("#upload_img_btn").html("Processing...");
					let formData = new FormData();
					formData.append("token", localStorage.getItem("token"));
					formData.append("storage_type", this.StorageType);
					formData.append("file", this.front_file);
					Axios.post(Endpoints.File.Upload, formData).then((Response) => {
					this.PopupLoader = false;
					if (Response?.data?.success == true) {
						this.license_front_image = Response.data.file;
						this.UploadBackFile();
					} else {
						this.$swal("Error in File Uploading", "", "error").then(() => {});
					}
					});
				} else {
					this.AddDocumentSubmit();
				}
				}else{
					if (this.$refs.file.files[0]) {
						this.PopupLoader = true;
						let formData = new FormData();
						formData.append("token", localStorage.getItem("token"));
						formData.append("storage_type", this.StorageType);
						formData.append("file", this.file);
						Axios.post(Endpoints.File.Upload, formData).then((Response) => {
							this.PopupLoader = false;
							if (Response?.data?.success == true) {
							this.NewDocument.files = Response.data.file;
							this.NewDocument.filename = this.file.name;
							this.AddDocumentSubmit();
							} else {
							this.$swal("Error in File Uploading", "", "error").then(() => {});
							}
						});
					}else{
						this.AddDocumentSubmit();
					}
					}
				}
		},
		EditDocument(document) {
			this.AddDocumentFormType='edit';
	    	this.NewDocument={};
	    	$("#file").val(null);
	      	this.file = "";           		
			this.NewDocument.id = document.document_id;
			this.NewDocument.title = document.title;
			this.NewDocument.category = document.category;
			this.NewDocument.sub_category = document.sub_category;		
			if (typeof document.fields === 'object') {
				if (!document.fields.vehicle && document.sub_category != 'driving_license') {
					document.fields.vehicle = {
					  title: "VRM",
					  type: "text",
					  required: false,
					  value: "",
					};
				}  
				this.NewDocument.fields = document.fields;  
				this.DocumentModelFields = document.fields;  
			}else{
				if (!document.fields.vehicle && document.sub_category != 'driving_license') {
					document.fields.vehicle = {
					  title: "VRM",
					  type: "text",
					  required: false,
					  value: "",
					};
				  }
				this.NewDocument.fields = JSON.parse(document.fields);
				this.DocumentModelFields = JSON.parse(document.fields);
			}			
			this.NewDocument.type = document.sub_category;					
			for (const index in this.NewDocument.fields) {			
				if(index=='mileage'){
					this.NewDocument.fields['mileage']['required']=true;
				}      
			}	
    	},
		AddDocumentSubmit() {
			this.NewDocument.driver_id = this.NewDriver.id;
			this.NewDocument.vehicle_id = 0;
			this.NewDocument.export_type = 1;
			this.NewDocument.scope = 1;
			
				this.$swal.fire({
					title: "Adding " + this.NewDocument.title + "...",
					text: "Please wait...",
					showConfirmButton: false,
					allowOutsideClick: false,
				});
				this.PopupLoader = true;
				this.NewDocument.token = localStorage.getItem("token");
				Axios.post(Endpoints.Dcoument.Create, this.NewDocument).then(
					(Response) => {
					this.PopupLoader = false;
					if (Response?.data?.success == true) {
						this.ShowAddDocument = false;
						this.GetDriverDetail();
						this.GetDriverDocument();
						$("#AddDocumentPopup .btn-danger").trigger("click");
						this.$swal
						.fire(
							this.NewDocument.title + " Added Successfully",
							"",
							"success"
						)
						.then(() => {});
						this.NewDocument = {};
					} else {
						this.$swal
						.fire(Response?.data?.message || "Something went wrong", "", "error")
						.then(() => {});
					}
					}
				);
				
			
		  },
		EditDriverInfo(){
			this.editForm = true;
		},
		EditEmploymentInfo(){
			this.editEmpForm = true;
		},
		EditLicenseInfo(){
			this.editLicenseForm = true;
		},
		EditCPCInfo(){
			this.editCPCForm = true;
		},
		EditADRInfo(){
			this.editADRForm = true;
		},
		EditHealthInfo(){
			this.editHealthForm = true;
		},
		DownloadDocument(document){
			window.open(this.ImageEndpoint+document.files,'_blank')
		},
		SetDriverType(type){
			$('.driver_type').removeClass('active');
			$('#'+type).addClass('active');
			this.NewDriver.company_driver_type = type;
			this.company_driver_type = type;
		},
		SetDriverAccountType(type){
			this.NewDriver.account_type = type;
		},
		SetDVLAMedicalConditions(type){
			this.NewDriver.is_dvla_notifiable = type;
		},
		SetDVLANotified(type){
			this.NewDriver.dvla_notified = type;
		},
		SetReferredToDoctor(type){
			this.NewDriver.referred_to_doctor = type;
		},
		SetContinueDriving(type){
			this.NewDriver.is_dvla_driving = type;
		},
		SetReceiveEmail(type){
			this.NewDriver.receive_email = type;
		},
		SetEyesight(type){
			this.NewDriver.eyesight_health = type;
		},
		handleFileUpload() {
			this.file = this.$refs.file.files[0];
	  	},
		UpdateDriverData(type) {
			this.SavingFile = true;
			if (this.$refs.file && this.$refs.file.files[0]) {
			let formData = new FormData();
			formData.append('token', localStorage.getItem('token'));
			formData.append('storage_type', 'CFDR');
			formData.append('file', this.file);
			Axios.post(Endpoints.File.Upload, formData).then((Response) => {
				this.SavingFile = false;
				if (Response?.data?.success == true) {
				  	this.NewDriver.new_image = Response.data.file;
					this.file = '';
					this.UpdateDriver(type);
				} else {
					this.$swal.fire('Error in File Uploading', '', 'error').then(() => {});
				}
			});
		}else{
			this.UpdateDriver(type);
		}
    	},
		CancelUpdateDriver(){
			this.editForm = false;
			this.GetDriverDetail();
		},
		CancelUpdateEmployment(){
			this.editEmpForm = false;
		},
		CancelUpdateLicense(){
			this.editLicenseForm = false;
		},
		CancelUpdateCPC(){
			this.editCPCForm = false;
		},
		CancelUpdateADR(){
			this.editADRForm = false;
		},
		CancelHealthUpdate(){
			this.editHealthForm = false;
			this.GetDriverDetail();
		},
		UpdateDriver(type) {
			this.submitted = true;
			this.$v.$touch();
			if (this.$v.$invalid) {
			  return;
			}
			if(type == 'Employment Details'){
				this.SavingEmp = true;
			}else if(type == 'License Details'){
				this.SavingLicense = true;
			}else if(type == 'CPC Details'){
				this.SavingCPC = true;
			}else if(type == 'ADR Details'){
				this.SavingADR = true;
			}else if(type == 'Health'){
				this.SavingHealth = true;
			}else{
				this.Saving = true;
			}
			
			//return true;
			Axios.post(Endpoints.Driver.Update, {token: localStorage.getItem('token'),...this.NewDriver}).then((Response) => {
			  this.Saving = false;
			  this.SavingEmp = false;
			  this.SavingLicense = false;
			  this.SavingCPC = false;
			  this.SavingADR = false;
			  this.SavingHealth = false;
			  if (Response?.data?.success) {
				this.$swal.fire(type+' Updated Successfully', '', 'success').then(() => {
					  //this.$router.push('/driver-profile/'+this.NewDriver.id);
					  this.file = '';
					  this.editForm = false;
					  this.editLicenseForm = false;
					  this.editEmpForm = false;
					  this.editCPCForm = false;
					  this.editADRForm = false;
					  this.editHealthForm = false;
					});
			  } else {
				this.$swal.fire({
					  title: 'Oops!',
					  text: Response?.data?.message || "Something went wrong",
					  icon: 'error',
					  confirmButtonText: 'Close',
					});
			  }
			});
	  },
	  	forceRerender() {
        	this.ComponentKey += 1;
      	},
      	isJson(str) {
            try {
                JSON.parse(str);
            } catch (e) {
                return false;
            }
            return true;
        },
		GetDriverDetail(){
			this.ShowLoader=true;
			Axios.post(Endpoints.Driver.Get, {token: localStorage.getItem('token'),'driver_id':this.DriverId}).then((Response) => {
				this.ShowLoader=false;
				if (Response?.data?.success) {
					this.NewDriver = Response.data.driver;
					this.GetDriverNotesList();                    
					if(this.isJson(this.NewDriver.license_category)){
						this.NewDriver.license_category = JSON.parse(this.NewDriver.license_category);
					}else{
						this.NewDriver.license_category = this.NewDriver.license_category.split(',');
					}
					this.forceRerender();
					/*if(this.NewDriver.driver_vehicle){
						this.Vehicle = this.NewDriver.driver_vehicle
					}*/
					if(this.NewDriver.driver_vehicle.length > 0){
						this.UpcomingEventNewHeight = 430;
						this.UpcomingEventNewHeightKey += 1;
					}
					if(this.NewDriver.driver_company){
						this.NewDriver.company_name = this.NewDriver.driver_company.name
						this.NewDriver.company_start_date = this.NewDriver.driver_company.start_date
						this.NewDriver.company_driver_id = this.NewDriver.driver_company.company_driver_id
						this.NewDriver.company_position = this.NewDriver.driver_company.position
						this.NewDriver.company_phone = this.NewDriver.driver_company.phone
						this.NewDriver.company_email = this.NewDriver.driver_company.email
						this.NewDriver.company_driver_type = this.NewDriver.driver_company.driver_type
						this.NewDriver.company_extra_field1 = this.NewDriver.driver_company.extra_field1
						this.NewDriver.company_extra_field2 = this.NewDriver.driver_company.extra_field2
						this.NewDriver.company_extra_field3 = this.NewDriver.driver_company.extra_field3
					}
					if(this.NewDriver.driver_vehicle.length == 1){
						this.vehicleLoop = false;
					}
					setTimeout(() => {
						new Swiper('.swiper', {
							// Optional parameters
							direction: 'horizontal',
							loop: this.vehicleLoop,
							// Navigation arrows
							navigation: {
							  nextEl: '.swiper-button-next',
							  prevEl: '.swiper-button-prev',
							},
						  });
					}, 1000);


				}else{
        			this.$router.push("/error-404");
        		}
			})
		},
		GetVehiclesListForAssign(){
			var obj={token: localStorage.getItem('token')}
			Axios.post(Endpoints.Vehicle.ListForAssign, obj).then((Response) => {
				if (Response?.data?.success) {
					this.Vehicles = Response.data.vehicles
				}
			})
		},
		UnAssignVehicle(vehicle_link_id){
			this.$swal.fire({
				title: 'Are you sure You want to UnAssign this Vehicle?',
				text: "You won't be able to revert this!",
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#514b71',
				cancelButtonColor: '#aaa',
				confirmButtonText: 'Yes, UnAssign it!',
				reverseButtons: true,
			}).then((result) => {
				if (result.isConfirmed) {
					this.$swal.fire({
						title: 'Deleting...',
						text: 'Please wait...',
						showConfirmButton: false,
						allowOutsideClick: false,
					});
					Axios.post(Endpoints.Driver.UnAssginVehicle, {token: localStorage.getItem('token'),vehicle_link_id:vehicle_link_id}).then((Response) => {
						if (Response?.data?.success == true) {
							this.GetDriverDetail();
							this.GetVehiclesListForAssign();
							this.$swal.fire('Vehicle UnAssigned Successfully','','success').then(() => {});
						} else {
							this.$swal.fire('Error:' + Response?.data?.message || "Something went wrong",'','error').then(() => {});
						}
					});
				}
			});
		},
		AssignVehicle(driver_id){
			this.ShowAssignVehicle = true;
			this.AssginVehicle.driver_id = driver_id
			this.AssginVehicle.vehicle_id = 0;
			this.GetVehiclesListForAssign();
		},
		SubmitAssignVehicle(driver_id){
			this.$swal.fire({
				title: 'Assigning...',
				text: 'Please wait...',
				showConfirmButton: false,
				allowOutsideClick: false,
			});
			if(this.AssginVehicle.vehicle_id > 0 && this.AssginVehicle.driver_id > 0){
				Axios.post(Endpoints.Driver.AssginVehicle, {token: localStorage.getItem('token'),driver_id:this.AssginVehicle.driver_id,vehicle_id:this.AssginVehicle.vehicle_id}).then((Response) => {
					if (Response?.data?.success == true) {
						this.GetDriverDetail();
						this.GetVehiclesListForAssign();
						this.ShowAssignVehicle = false;
						$('#AssignVehicleModel .btn-close').trigger('click');
						this.$swal.fire('Vehicle Assigned Successfully','','success').then(() => {});
					} else {
						this.$swal.fire('Error:' + Response?.data?.message || "Something went wrong",'','error').then(() => {});
					}
				});
			}else{
				this.$swal.fire({
					'icon':'error',
					'title': 'Please Select Vehicle',
				});
			}
		},
		LoadProfileData(){
			this.GetDriverDetail();
		},
		UpdateDriverStatus(driver_id,status) {
			if(status == 1){
				var title = 'Are you sure You want to make active this Driver?';
				var btnName = 'Yes, Activate It!';
				var successMessage = 'Driver Activated Successfully';
				var subHeading = '';
			}else if(status == 3){
				var title = 'Are you sure You want to archive this Driver?';
				var btnName = 'Yes, Archive It!';
				var successMessage = 'Driver Archived Successfully';
				var subHeading = 'All assigned vehicles, trailers, assets will be unassigned and user will be unlinked from mobile app (in case using).';
			}
			this.$swal.fire({
				title: title,
				text: subHeading,
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#514b71',
				cancelButtonColor: '#aaa',
				confirmButtonText: btnName,
				reverseButtons: true,
			}).then((result) => {
				if (result.isConfirmed) {
					this.$swal.fire({
						title: 'Processing...',
						text: 'Please wait...',
						showConfirmButton: false,
						allowOutsideClick: false,
					});
					Axios.post(Endpoints.Driver.StatusUpdate, {token: localStorage.getItem('token'),id: driver_id,status:status}).then((Response) => {
						if (Response?.data?.success == true) {
							this.GetDriverDetail();
							this.$swal.fire(successMessage,'','success').then(() => {});
						} else {
							this.$swal.fire('Error:' + Response?.data?.message || "Something went wrong",'','error').then(() => {});
						}
					});
				}
			});
		},
		DeleteDriver(driver_id) {
			this.$swal.fire({
				title: 'Are you sure You want to delete this Driver?',
				text: 'You will not be able to revert this!',
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#514b71',
				cancelButtonColor: '#aaa',
				confirmButtonText: 'Yes, delete it!',
				reverseButtons: true,
			}).then((result) => {
				if (result.isConfirmed) {
					this.$swal.fire({
						title: 'Processing...',
						text: 'Please wait...',
						showConfirmButton: false,
						allowOutsideClick: false,
					});
					Axios.post(Endpoints.Driver.Delete, {token: localStorage.getItem('token'),id: driver_id}).then((Response) => {
						if (Response?.data?.success == true) {
							this.$router.push('/drivers-list');
							this.$swal.fire('Driver Deleted Successfully','','success').then(() => {});
						} else {
							this.$swal.fire('Error:' + Response?.data?.message || "Something went wrong",'','error').then(() => {});
						}
					});
				}
			});
		},
		GetDriverDocumentSubcategories(){
			Axios.post(Endpoints.Driver.DocumentSubcategories, {token: localStorage.getItem('token'),'driver_id':this.DriverId}).then((Response) => {
				if (Response?.data?.success) {
					this.DocumentSubcategories = Response.data.subcategories;
				}
			})
		},
		GetDriverDocument(){
			Axios.post(Endpoints.Driver.Documents, {token: localStorage.getItem('token'),'driver_id':this.DriverId,'search_key':this.DocFilter}).then((Response) => {
				if (Response?.data?.success) {
					this.Documents = {
										documents: Response.data.documents.data,
										page: 1,
										last_page: Response.data.documents.last_page,
									};
					this.CurrentCPCDoc = Response.data.latest_cpc_doc;	
					this.CurrentADRDoc = Response.data.latest_adr_doc;	
					this.CurrentLicenceDoc = Response.data.latest_driving_license;	
					this.UpcomingEventNewHeightKey += 1;
				}
			})
		},
		ViewMore(currentPage){
			var nextPage = currentPage + 1;
			Axios.post(Endpoints.Driver.Documents, {
				token: localStorage.getItem("token"),
				driver_id: this.DriverId,
				'search_key':this.DocFilter,
				page:nextPage
			}).then((Response) => {
				if (Response?.data?.success) {
				this.Documents.page = nextPage;
				this.Documents.last_page = Response.data.documents.last_page;
				Response.data.documents.data.forEach((element) => {
					this.Documents.documents.push(
					element
					);
				});
				}
			});
		},
		ViewDetailDocument(document){
			this.ViewDocument = document;
			this.ShowViewDetailModel = true;
			this.ShowMap = false;
			if (
				this.ViewDocument.fields.latitude &&
				this.ViewDocument.fields.latitude.value &&
				this.ViewDocument.fields.latitude.value != "" &&
				this.ViewDocument.fields.longitude &&
				this.ViewDocument.fields.longitude.value &&
				this.ViewDocument.fields.longitude.value != ""
			) {
				this.ShowMap = true;
				const marker = {
				lat: parseFloat(this.ViewDocument.fields.latitude.value),
				lng: parseFloat(this.ViewDocument.fields.longitude.value),
				};
				this.locationPoints = marker;
				this.infoOptions.content =
				'<div id="mapcontent"><h1 id="firstHeading" class="firstHeading" style="margin: 0px;">' +
				this.ViewDocument.fields.vehicle.value +
				"</h1></div>";
			}
		},
		UnlinkDriverDocument(document_link_id) {
			this.$swal.fire({
				title: 'Are you sure You want to delete?',
				text: "You won't be able to revert this!",
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#514b71',
				cancelButtonColor: '#aaa',
				confirmButtonText: 'Yes, delete it!',
				reverseButtons: true,
			}).then((result) => {
				if (result.isConfirmed) {
					this.$swal.fire({
						title: 'Deleting...',
						text: 'Please wait...',
						showConfirmButton: false,
						allowOutsideClick: false,
					});
			      	Axios.post(Endpoints.Driver.UnlinkDocument, {token: localStorage.getItem('token'),document_link_id: document_link_id}).then((Response) => {
			        	if (Response?.data?.success == true) {
							this.$swal.close();
			          		this.GetDriverDocument();
			          		this.$swal.fire('Document Unlinked Successfully','','success').then(()=>{})
			        	} else {
							this.$swal.fire('Error:' + Response?.data?.message || "Something went wrong",'','error').then(() => {});
			        	}
			      	});
			    }
			})
	    },
	    GetUpcomingEventList(){
			Axios.post(Endpoints.Dashboard.UpcomingEvent, {token: localStorage.getItem('token'),'RequestFor':'DriverProfile',"DriverId":this.DriverId}).then((Response) => {
				if (Response?.data?.success) {
					this.UpcomingEvent = Response.data.upcoming_event
				}
			})
		},
		FitToDrive(driver_id) {
			this.$swal.fire({
				title: 'Driver Authorised To Drive',
				text: "You are about to mark this driver as authorised to drive",
				//icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#514b71',
				cancelButtonColor: '#aaa',
				confirmButtonText: 'Continue',
				reverseButtons: true,
			}).then((result) => {
				if (result.isConfirmed) {
					this.$swal.fire({
						title: 'Processing...',
						text: 'Please wait...',
						showConfirmButton: false,
						allowOutsideClick: false,
					});
					Axios.post(Endpoints.Driver.FitToDrive, {token: localStorage.getItem('token'),driver_id: driver_id}).then((Response) => {
						if (Response?.data?.success == true) {
							this.NewDriver.unfit_to_drive = 0;
							this.$swal.fire('Driver Marked as Authorised To Driver Successfully','','success').then(() => {});
						} else {
							this.$swal.fire('Error:' + Response?.data?.message || "Something went wrong",'','error').then(() => {});
						}
					});
				}
			});
		},
		UnfitToDrive(driver_id) {
			this.$swal.fire({
				title: 'Driver Unauthorised To Drive',
				text: "You are about to mark this driver as unauthorised  to drive",
				//icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#514b71',
				cancelButtonColor: '#aaa',
				confirmButtonText: 'Continue',
				reverseButtons: true,
			}).then((result) => {
				if (result.isConfirmed) {
					this.$swal.fire({
						title: 'Processing...',
						text: 'Please wait...',
						showConfirmButton: false,
						allowOutsideClick: false,
					});
					Axios.post(Endpoints.Driver.UnfitToDrive, {token: localStorage.getItem('token'),driver_id: driver_id}).then((Response) => {
						if (Response?.data?.success == true) {
							this.NewDriver.unfit_to_drive = 1;
							this.$swal.fire('Driver Marked as Unauthorised To Driver Successfully','','success').then(() => {});
						} else {
							this.$swal.fire('Error:' + Response?.data?.message || "Something went wrong",'','error').then(() => {});
						}
					});
				}
			});
		},
		DocumentModelLoadCategories() {      		
      		this.DocumentModelCategories = [];
      		Axios.post(Endpoints.Dcoument.Categories,{token: localStorage.getItem("token")}).then((Response) => {
        		this.PopupLoader = false;
        		if (Response?.data?.success == true) {
          			if (Response.data.categories.length > 0) {
            			Response.data.categories.forEach((element) => {
              				this.DocumentModelCategories.push({id: element.category_name,title: element.category_name});
            			});
            			//this.DocumentModelCategories.push({ id: -1, title: "Add New" });
          			} else {
            			//this.DocumentModelCategories.push({ id: -1, title: "Add New" });
      				}
        		}
      		});
    	},
    	NewDocumentOpen() {
    		this.AddDocumentFormType='add_new';	    		    	
	    	this.NewDocument = {};
			this.NewDocument.category = 0;	
			this.NewDocument.sub_category = 0;						
			this.DocumentModelSubCategories = [];
			this.DocumentModelFields = {};	
	    	$("#file").val(null);	      					
    	},
    	onSelectCategory(evt) {     		   		
        	this.PopupLoader = true;
        	this.DocumentModelSubCategories = [];
        	this.DocumentModelFields = {};
        	this.NewDocument.fields = {};
			this.NewDocument.sub_category = 0;	
        	Axios.post(Endpoints.Dcoument.SubCategories, {token: localStorage.getItem("token"),category: this.NewDocument.category}).then((Response) => {
          		this.PopupLoader = false;
          		if (Response?.data?.success == true) {
          			if (Response?.data?.subcategories.length > 0 ) {
            			Response.data.subcategories.forEach((element) => {
              				this.DocumentModelSubCategories.push({id: element,title: element});
            			});
            			//this.DocumentModelSubCategories.push({ id: -1, title: "Add New" });
          			} else {
            			//this.DocumentModelSubCategories.push({ id: -1, title: "Add New" });
      				}
        		}        		
        	});      	
    	},
    	onSelectSubCategory() {      
      		if (this.NewDocument.sub_category != 0) {
        		this.PopupLoader = true;
        		Axios.post(Endpoints.Dcoument.Model, {token: localStorage.getItem("token"),category: this.NewDocument.category,sub_category: this.NewDocument.sub_category}).then((Response) => {
          			this.PopupLoader = false;
          			if (Response?.data?.success == true && Response.data.models[0]) {
            			var model = Response.data.models[0];            			
            			this.NewDocument.title = model.title;
						this.NewDocument.category = model.category;
						this.NewDocument.sub_category = model.sub_category;				
						this.NewDocument.type = model.sub_category;
            			this.NewDocument.fields = JSON.parse(model.fields);
            			this.DocumentModelFields = JSON.parse(model.fields);
            			for (const index in this.DocumentModelFields) {
			              	if (index == "vehicle") {
			                	this.NewDocument.fields["vehicle"]["value"] = [];
			                	this.DocumentModelFields["vehicle"]["value"] = [];
			              	}
              				if (index == "mileage") {
                				this.NewDocument.fields["mileage"]["required"] = true;
                				this.DocumentModelFields["mileage"]["required"] = true;
              				}
            			}
            			        			
          			}
        		});
      		}
    	},
		ResetAPPPassword(){
			this.$swal.fire({
				title: 'Are you sure You want to Reset App Password?',
				text: "You won't be able to revert this!",
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#514b71',
				cancelButtonColor: '#aaa',
				confirmButtonText: 'Yes, Reset it!',
				reverseButtons: true,
			}).then((result) => {
				if (result.isConfirmed) {
					this.$swal.fire({
						title: 'Processing...',
						text: 'Please wait...',
						showConfirmButton: false,
						allowOutsideClick: false,
					});
					Axios.post(Endpoints.Driver.ResetAppPassword, {token: localStorage.getItem('token'),driver_id: this.DriverId}).then((Response) => {
						if (Response?.data?.success == true) {
							this.$swal.fire('Driver`s app password updated successfully. New password is \n '+Response.data.password,'','success').then(() => {});
						} else {
							this.$swal.fire('Error:' + Response?.data?.message || "Something went wrong",'','error').then(() => {});
						}
					});
				}
			});
		},
		
		registerDriverOnMobile(){
			this.$swal.fire({
				title: 'Are you sure You want to Register Driver on Mobile?',
				text: "",
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#514b71',
				cancelButtonColor: '#aaa',
				confirmButtonText: 'Yes, Register it!',
				reverseButtons: true,
			}).then((result) => {
				if (result.isConfirmed) {
					this.$swal.fire({
						title: 'Processing...',
						text: 'Please wait...',
						showConfirmButton: false,
						allowOutsideClick: false,
					});
					Axios.post(Endpoints.Driver.registerDriverOnMobile, {token: localStorage.getItem('token'),driver_id: this.DriverId}).then((Response) => {
						if (Response?.data?.success == true) {
							this.GetDriverDetail();
							this.$swal.fire({
								title: 'Success',
								html: Response?.data?.message || "Something went wrong",
								icon: 'success',
								showCancelButton: false,
								reverseButtons: true,
							}).then(() => {});

						} else {
							if (Response && Response.data && !Response.data.confirmUpdate) {
								this.$swal.fire({
								title: 'Alert!',
								html: Response?.data?.message || "Something went wrong",
								icon: 'error',
								showCancelButton: false,
								reverseButtons: true,
							}).then(() => {});

							}else{
								this.$swal.fire({
								title: 'Confirm!',
								text: Response?.data?.message || "Something went wrong",
								icon: 'warning',
								showCancelButton: true,
								confirmButtonColor: '#514b71',
								cancelButtonColor: '#aaa',
								confirmButtonText: 'Connect',
								reverseButtons: true,
									html: `<div class="connect-driver-mobile-popup">
											<p>`+Response?.data?.message || "Something went wrong"+`</p>
											<div style="text-align:left;">
											<label>
												<input type="checkbox" id="requirePassword" />
												Reset mobile app password
											</label>
											<div id="passwordWrapper" style="margin-top:10px; display:none;">
												New Password: <input type="password" id="driverPassword" class="swal2-input" placeholder="Enter New Password" />
											</div>
										</div>
									</div>
									`,
									didOpen: () => {
										const checkbox = document.getElementById('requirePassword');
										const wrapper = document.getElementById('passwordWrapper');
										 if (checkbox && wrapper) {
											checkbox.addEventListener('change', () => {
											wrapper.style.display = checkbox.checked ? 'block' : 'none';
											});
										}
									},
									preConfirm: () => {
										const popup = this.$swal.getPopup();

										const checkbox = popup.querySelector('#requirePassword');
										const passwordInput = popup.querySelector('#driverPassword');

										const isChecked = checkbox?.checked || false;
										const password = passwordInput?.value || "";

										if (isChecked) {
											if (!password) {
												this.$swal.showValidationMessage("Password is required if checkbox is checked");
												return false;
											}

											// Password validation rules
											const minLength = /.{8,}/;
											const hasUpper = /[A-Z]/;
											const hasNumber = /[0-9]/;
											const hasSpecial = /[!@#$%^&*(),.?":{}|<>]/;

											if (!minLength.test(password)) {
												this.$swal.showValidationMessage("Password must be at least 8 characters long");
												return false;
											}
											if (!hasUpper.test(password)) {
												this.$swal.showValidationMessage("Password must include at least 1 uppercase letter");
												return false;
											}
											if (!hasNumber.test(password)) {
												this.$swal.showValidationMessage("Password must include at least 1 number");
												return false;
											}
											if (!hasSpecial.test(password)) {
												this.$swal.showValidationMessage("Password must include at least 1 special character");
												return false;
											}
										}

										return { requirePassword: isChecked, password: password };
									}
								}).then((result) => {
									if (result.isConfirmed) {
										this.$swal.fire({
											title: 'Processing...',
											text: 'Please wait...',
											showConfirmButton: false,
											allowOutsideClick: false,
										});
										Axios.post(Endpoints.Driver.connectDriverWithMobileUser, {
											token: localStorage.getItem('token'),
											driver_id: this.DriverId,
											password: result.value.password || null
										}).then((Response) => {
											if (Response?.data?.success == true) {
												this.GetDriverDetail();
												this.$swal.fire({
												title: 'Success',
												html: Response?.data?.message || "Something went wrong",
												icon: 'success',
												showCancelButton: false,
												reverseButtons: true,
											}).then(() => {});
											} else {
												this.$swal.fire({
													title: 'Alert!',
													html: Response?.data?.message || "Something went wrong",
													icon: 'error',
													showCancelButton: false,
													reverseButtons: true,
												}).then(() => {});
											}
										});
									}
								});
							}
						}
					});
				}
			});
		},
		
		DisconnectAPPUser(email) {
			this.$swal.fire({
				title: 'Are you sure you want to disconnect this driver from the app user ('+email+')?',
				text: '',
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#514b71',
				cancelButtonColor: '#aaa',
				confirmButtonText: 'Yes, Disconnect it!',
				reverseButtons: true,
			}).then((result) => {
				if (result.isConfirmed) {
					this.$swal.fire({
						title: 'Processing...',
						text: 'Please wait...',
						showConfirmButton: false,
						allowOutsideClick: false,
					});
					Axios.post(Endpoints.Driver.DisconnectAPPUser, {token: localStorage.getItem('token'),driver_id: this.DriverId}).then((Response) => {
						if (Response?.data?.success == true) {
							this.$swal.fire('Driver successfully disconnected from App user','','success').then(() => {});
							
							 setTimeout(() => {
								window.location.reload(); 
							  }, 2000);
						} else {
							this.$swal.fire('Error:' + Response?.data?.message || "Something went wrong",'','error').then(() => {});
						}
					});
				}
			});
		},
	}



	
}
